import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarPlus } from '@fortawesome/free-solid-svg-icons';
import '../../Styles/DatePickerStyles.scss';
import DatePickerBox from './DatePickerBox';
import { _formatDateForDisplay } from '../../Helpers/DateHelpers';

const DatePicker = ({
  id,
  selectedValue,
  label,
  onChange,
  tabIndex,
  openFilter,
  setOpenFilter,
}) => {
  const showContent = openFilter === id;
  const openMenu = () => {
    const filterToSet = openFilter === id ? '' : id;
    setOpenFilter(filterToSet);
  };
  const handleSelection = (value) => {
    setOpenFilter('');
    onChange(value, 'date');
  };
  return (
    <div className="date_picker_container">
      <div className="title">{label}</div>
      <div className="header" onClick={openMenu} tabIndex={tabIndex}>
        <p>{_formatDateForDisplay(selectedValue)}</p>
        <FontAwesomeIcon icon={faCalendarPlus} />
      </div>
      {showContent && (
        <div className="content">
          <DatePickerBox
            selectedValue={selectedValue}
            handleSelection={handleSelection}
          />
        </div>
      )}
    </div>
  );
};

DatePicker.propTypes = {
  selectedValue: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  tabIndex: PropTypes.number,
  openFilter: PropTypes.string,
  setOpenFilter: PropTypes.func,
};
DatePicker.defaultProps = {
  selectedValue: null,
  tabIndex: null,
  openFilter: null,
  setOpenFilter: null,
};

export default DatePicker;
